var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.hotbList.length
    ? _c("div", [
        _vm.isTenant
          ? _c("div", { staticClass: "hotb-section__header" }, [
              _vm._v(_vm._s(_vm.$t("handoverTakeback"))),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "ul",
          { staticClass: "hotb-list" },
          _vm._l(_vm.handoverList, function (hotb) {
            return _c("li", { key: hotb.id, staticClass: "row" }, [
              _c("div", { staticClass: "hotb-info__type handover" }),
              _vm._v(" "),
              _c("div", { staticClass: "hotb-info" }, [
                _c(
                  "a",
                  {
                    staticClass: "hotb-info__item-link",
                    on: {
                      click: function ($event) {
                        return _vm.navToDetail(hotb.id)
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.hotbDisplayName(hotb)))]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "hotb-info__item-status" }, [
                  _vm._v(_vm._s(_vm.trackStatus(hotb))),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "hotb-info_item-date status" }, [
                _vm._v(_vm._s(_vm.dateUtil.formatDate(hotb.transactionDate))),
              ]),
            ])
          }),
          0
        ),
        _vm._v(" "),
        _c(
          "ul",
          { staticClass: "hotb-list" },
          _vm._l(_vm.takebackList, function (hotb) {
            return _c("li", { key: hotb.id, staticClass: "row" }, [
              _c("div", { staticClass: "hotb-info__type takeback" }),
              _vm._v(" "),
              _c("div", { staticClass: "hotb-info" }, [
                _c(
                  "a",
                  {
                    staticClass: "hotb-info__item-link",
                    on: {
                      click: function ($event) {
                        return _vm.navToDetail(hotb.id)
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.hotbDisplayName(hotb)))]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "hotb-info__item-status" }, [
                  _vm._v(_vm._s(_vm.trackStatus(hotb))),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "hotb-info_item-date status" }, [
                _vm._v(_vm._s(_vm.dateUtil.formatDate(hotb.transactionDate))),
              ]),
            ])
          }),
          0
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }